// Canonical note slug map — keep in sync with /app/backend/scripts/generate_note_images.py
// Maps every possible note string used across scents to a transparent PNG slug.

export const NOTE_TO_SLUG = {
  "Sandalwood": "sandalwood",
  "Jasmine": "jasmine",
  "Jasmine Grandiflorum": "jasmine",
  "Sweet Vanilla": "vanilla",
  "Clean Vanilla": "vanilla",
  "Vanilla": "vanilla",
  "Madagascan Vanilla": "vanilla",
  "Madagascan Bourbon Vanilla": "vanilla",
  "Caramel": "caramel",
  "Lavender": "lavender",
  "Lemongrass": "lemongrass",
  "Amber": "amber",
  "Musk": "musk",
  "Grapefruit": "grapefruit",
  "Hyacinth": "hyacinth",
  "Raspberry": "raspberry",
  "Cherry": "cherry",
  "Strawberry": "strawberry",
  "Blackberry": "blackberry",
  "Blueberry": "blueberry",
  "Violet": "violet",
  "Bergamot": "bergamot",
  "Calabrian Bergamot": "bergamot",
  "Honeyed Neroli": "neroli",
  "May Rose": "rose",
  "Rose": "rose",
  "Ylang Ylang": "ylang_ylang",
  "Iris": "iris",
  "Lily of the Valley": "lily_of_the_valley",
  "Cedarwood": "cedarwood",
  "Oakmoss": "oakmoss",
  "Vetiver": "vetiver",
  "Patchouli": "patchouli",
  "Aldehydes": "aldehydes",
  "Civet": "civet",
  "Ambergris": "ambergris",
  "Sicilian Orange": "orange",
  "Tonka Bean": "tonka_bean",
  "Saffron": "saffron",
  "Amberwood": "amberwood",
  "Fir Resin": "fir_resin",
  "Cashmeran": "cashmeran",
};

export function noteToImageSrc(note) {
  const slug = NOTE_TO_SLUG[note];
  if (!slug) return null;
  return `/assets/notes/${slug}.png`;
}

// Deduplicate by slug so the flat-lay never shows the same PNG twice
export function uniqueNoteImages(notes = []) {
  const seen = new Set();
  const out = [];
  for (const note of notes) {
    const slug = NOTE_TO_SLUG[note];
    if (!slug || seen.has(slug)) continue;
    seen.add(slug);
    out.push({ note, slug, src: `/assets/notes/${slug}.png` });
  }
  return out;
}
